import ReferenceSection from './strategies/ReferenceSection';
import ReferencesSectionSection from './strategies/ReferencesSectionSection';
import AttachmentSection from './strategies/AttachmentSection';
import AttachmentsGroupSection from './strategies/AttachmentsGroupSection';
import AnnouncementSection from './strategies/AnnouncementSection';

export interface FeaturedContentItem {
  type: 'reference' | 'references_section' | 'attachment' | 'attachments_group' | 'announcement';
  id: number;
  [key: string]: any;
}

const strategyRegistry: Record<string, React.ComponentType<{ item: FeaturedContentItem; index: number }>> = {
  reference: ReferenceSection,
  references_section: ReferencesSectionSection,
  attachment: AttachmentSection,
  attachments_group: AttachmentsGroupSection,
  announcement: AnnouncementSection,
};

interface FeaturedContentSectionProps {
  items?: FeaturedContentItem[];
}

export default function FeaturedContentSection({ items }: FeaturedContentSectionProps) {
  if (!items?.length) return null;

  return (
    <>
      {items.map((item, index) => {
        const Component = strategyRegistry[item.type];
        if (!Component) return null;
        return <Component key={`${item.type}-${item.id}`} item={item} index={index} />;
      })}
    </>
  );
}
